import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { Link } from "@tanstack/react-router";
import { Home, ChevronRight } from "lucide-react";

export type BreadcrumbItem = {
  label: string;
  href?: string;
  params?: any;
};

export function SiteLayout({
  children,
  breadcrumbs,
}: {
  children: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}) {
  return (
    <div className="flex-1 flex flex-col">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <div className="w-full" style={{ backgroundColor: "lab(33.9054 -30.062 11.8033)" }}>
          <nav className="mx-auto max-w-7xl px-5 py-6 lg:px-8 flex flex-wrap items-center text-xs uppercase tracking-[0.18em] text-white">
            <Link to="/" className="hover:opacity-80 transition-opacity flex items-center">
              <Home className="h-3.5 w-3.5" />
            </Link>
            {breadcrumbs.map((crumb, idx) => (
              <div key={idx} className="flex items-center">
                <ChevronRight className="h-3.5 w-3.5 mx-2 opacity-50" />
                {crumb.href ? (
                  <Link
                    to={crumb.href as any}
                    params={crumb.params}
                    className="hover:opacity-80 transition-opacity"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="font-medium">{crumb.label}</span>
                )}
              </div>
            ))}
          </nav>
        </div>
      )}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="flex-1 flex flex-col bg-white pb-24"
      >
        {children}
      </motion.div>
    </div>
  );
}
